import { render, staticRenderFns } from "./ForumTopicRow.vue?vue&type=template&id=0c3bc019&scoped=true&"
import script from "./ForumTopicRow.vue?vue&type=script&lang=js&"
export * from "./ForumTopicRow.vue?vue&type=script&lang=js&"
import style0 from "./ForumTopicRow.vue?vue&type=style&index=0&id=0c3bc019&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3bc019",
  null
  
)

export default component.exports